

import hero from "../assests/hero.png";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${hero})` }}
    >
      {/* Overlay */}

      <div className="absolute inset-0 bg-black/45"></div>

      <div className="relative max-w-7xl mx-auto min-h-screen flex items-center px-5 sm:px-8 md:px-12 lg:px-20 xl:px-24 py-20">

        <motion.div
          initial={{ opacity: 0, x: -80 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className="max-w-3xl text-white"
        >

          <h1 className="font-bold leading-tight">

            <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              Fresh Coconuts
            </span>

            <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl mt-2">
              Premium Quality
            </span>

            <span className="block text-lime-400 text-3xl sm:text-4xl md:text-5xl lg:text-6xl mt-3">
              Direct From The Farm
            </span>

          </h1>

          <p className="mt-8 text-base sm:text-lg md:text-xl leading-8 text-gray-200 max-w-2xl">

            We supply premium-quality Fresh Coconuts, Tender Coconuts,
            Coconut Oil, Coconut Leaves, Coconut Husk, Coir Products
            and many other coconut-based products directly from our farms
            to retailers, wholesalers and exporters.

          </p>

          {/* Buttons */}

          <div className="mt-10 flex flex-col sm:flex-row gap-5">

            <Link
              to="products"
              smooth={true}
              duration={700}
              offset={-80}
            >
              <button className="w-full sm:w-auto bg-green-700 hover:bg-green-800 text-white px-8 py-4 rounded-xl text-lg font-semibold transition duration-300 shadow-lg cursor-pointer">

                Explore Products

              </button>
            </Link>

            <Link
              to="contact"
              smooth={true}
              duration={700}
              offset={-80}
            >
              <button className="w-full sm:w-auto bg-white hover:bg-gray-100 text-black px-8 py-4 rounded-xl text-lg font-semibold transition duration-300 shadow-lg cursor-pointer">

                Contact Us

              </button>
            </Link>

          </div>

          {/* Feature Cards */}

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-14">

            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20">
              <h3 className="text-2xl font-bold text-lime-400">100%</h3>
              <p className="text-sm mt-1">Farm Fresh</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20">
              <h3 className="text-2xl font-bold text-lime-400">Premium</h3>
              <p className="text-sm mt-1">Quality</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20">
              <h3 className="text-2xl font-bold text-lime-400">Bulk</h3>
              <p className="text-sm mt-1">Supply</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20">
              <h3 className="text-2xl font-bold text-lime-400">Fast</h3>
              <p className="text-sm mt-1">Delivery</p>
            </div>

          </div>

        </motion.div>

      </div>

    </section>
  );
}

export default Hero;